module.exports = __webpack_public_path__ + "static/media/logo.884d8881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 96
// module chunks = 0